module.exports = __webpack_public_path__ + "static/media/0_2018_09_23-2.94959afc.jpg";